import $ from 'jquery';

const ENDPOINT = '/dd_twitter_feed/get_tweets';

export default class TwitterFeed {
  constructor(element) {
    this.element = element;
    this.$element = $(element);
    this.fail = this.fail.bind(this);
    this.success = this.success.bind(this);

    const url = new Request(ENDPOINT);

    // Request homepage.
    fetch(url)
      .then(this.validate)
      .then(this.success)
      .catch(this.fail);
  }

  // Validate response from our request.
  /* eslint-disable class-methods-use-this */
  validate(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.text();
  }

  fail(error) {
    this.error = error;
  }

  success(result) {
    this.$element.find('.tweets').html(result);
  }

  complete() {
    this.$element.addClass('ready');
  }
}
